import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Approach } from "@/components/site/Approach";
import { Clients } from "@/components/site/Clients";
import { Services } from "@/components/site/Services";
import { Pricing } from "@/components/site/Pricing";
import { JournalTeaser } from "@/components/site/JournalTeaser";
import { Contact } from "@/components/site/Contact";
import { scrollToId } from "@/lib/lenis";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "Scale Solutions by Sadiya — Coaching & Consulting";
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <About />
      <Approach />
      <Clients />
      <Services />
      <Pricing />
      <JournalTeaser />
      <Contact />
    </main>
  );
}
